module.exports = __webpack_public_path__ + "assets/img/progress-icon-active.9221b97d.png";